<template>
  <div>
    <SectionHeader slot="header">
      <h1>Password Reset</h1>
    </SectionHeader>
    <div v-if="passwordReset">
      <Alert class="success">
        <Icon
          slot="icon"
          type="check"
          :size="2"
          padding=".5em"
          backgroundColor="transparent"
        />
        <p>
          Your password has been succesfully reset
        </p>
      </Alert>
      <DividerSeparator>
        <DecoratedButton
          type="link"
          :route="{ name: pages.AUTH_LOGIN }"
          class="wide short dark-blue"
          fontSize=".8em"
        >
          CLICK HERE TO LOG IN
        </DecoratedButton>
      </DividerSeparator>
    </div>
    <SectionWrapper v-else class="whiteframe shadowframe">
      <form v-on:submit.prevent="onSubmit">
        <FieldWrapper>
          <input
            type="password"
            v-model="user.password"
            name="password"
            placeholder="New Password"
            v-validate="validatorDefinitions.password_new"
            data-vv-scope="password-reset"
          />
          <span slot="errors" v-if="errors.has('password', 'password-reset')">{{
            errors.first("password", "password-reset")
          }}</span>
        </FieldWrapper>
        <FieldWrapper>
          <input
            type="password"
            v-model="user.password_confirmation"
            name="password_confirmation"
            placeholder="New Password Confirmation"
            v-validate="validatorDefinitions.password_confirmation"
            data-vv-scope="password-reset"
          />
          <span
            slot="errors"
            v-if="errors.has('password_confirmation', 'password-reset')"
            >{{ errors.first("password_confirmation", "password-reset") }}</span
          >
        </FieldWrapper>
        <DecoratedButton type="submit" class="wide" :loading="loading">
          SET NEW PASSWORD
        </DecoratedButton>
      </form>
    </SectionWrapper>
  </div>
</template>

<script>
export default {
  name: "auth-password-reset",
  data: function() {
    return {
      user: {
        password: "",
        password_confirmation: ""
      },
      passwordReset: false,
      loading: false
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll("password-reset").then(valid => {
        if (valid) {
          this.loading = true;
          this.services.UserResource.resetPassword(
            {
              id: this.$route.params.id
            },
            this.user
          )
            .then(() => {
              this.loading = false;
              this.passwordReset = true;
            })
            .catch(err => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
